export default __webpack_public_path__ + "static/media/gallery-8.feb94648.png";